<template>
  <TolModal
    :title="$t('projects.details.contacts.labels.addClientContact')"
    :submit-button-text="$t('projects.details.labels.save')"
    @close="clearFormAndClose()"
    @submit="save()"
  >
    <template v-slot:body>
      <form>
        <div class="form-group">
          <div class="form-control">
            <tol-type-ahead
              v-if="displaySearch"
              :search-params="{
                url: '/client-contact/user-quick-search',
                searchKeys: ['username', 'first_name', 'last_name', 'email'],
                client_id: project.clientId
              }"
              class="blue contact-box"
              @select-item="OnContactSelect($event)"
            >
              <template v-slot="{ value }">
                {{ value.last_name }}, {{ value.first_name }}
              </template>
            </tol-type-ahead>
            <div v-else>
              {{ projectClientContact.last_name }}, {{ projectClientContact.first_name }}
            </div>
          </div>
        </div>
      </form>
    </template>
  </TolModal>
</template>

<script>
import TolModal from '@/app/components/TolModal';
import TolTypeAhead from '@/app/components/TolTypeAhead';

export default {
  name: 'MapProjectClientContactModal',
  components: {
    TolTypeAhead,
    TolModal
  },
  props: {
    project: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      displaySearch: true,
      projectClientContact: {
        projectReferenceNumber: '',
        user_reference_number: '',
        first_name: '',
        last_name: ''
      }
    };
  },
  computed: {
    formErrors() {
      return this.$store.getters.EventTypeValidationErrors;
    }
  },
  mounted() {
    this.projectClientContact.projectReferenceNumber = this.project.reference_number;
  },
  methods: {
    clearFormAndClose() {
      this.projectClientContact = {
        projectReferenceNumber: '',
        user_reference_number: '',
        first_name: '',
        last_name: ''
      };
      this.$emit('close', this.projectClientContact);
    },
    async save() {
      this.$emit('save', this.projectClientContact);
    },
    OnContactSelect(clientContact) {
      this.displaySearch = false;
      this.projectClientContact.projectReferenceNumber = this.project.reference_number;
      this.projectClientContact.first_name = clientContact.first_name;
      this.projectClientContact.last_name = clientContact.last_name;
      this.projectClientContact.user_reference_number = clientContact.reference_number;
    }
  }
};
</script>

<style scoped lang="scss">
.form-group > div {
  margin-bottom: 1rem;
}

.form-row {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media only screen and (min-width: 600px) {
    flex-direction: row;
  }
}

@media only screen and (max-width: 599px) {
  .form-row > div {
    margin-bottom: 1rem;
  }
}
</style>
